var $ = require('jquery');
var Ajax = require('../utils/ajax');
var Minicart = require('./header/minicart');
var CartOverlay = require('./checkout/cartoverlay');
var Util = require('../utils/util');
var Progress = require('../utils/progress');

function setCardAmount(amount) {
    $('.js-gift-certificate-selected-value').each(function (i, element) {
        if (element.tagName.toLowerCase() === 'input') {
            element.value = amount;
        } else {
            element.innerText = amount;
        }
    });
}

function initializeEvents() {
    if (document.getElementById('gift-certificate-main')) {
        $('.js-gift-certificate-designs').on('click', '.js-gift-certificate-design', function () {
            // get the image for the selected design.
            var $target = $(this);
            var $img = $target.find('img');
            var $previewImages = $('.js-gift-certificate-design-selected-img');

            $target.closest('.js-gift-certificate-designs').find('.js-gift-certificate-design').removeClass('selected');
            $target.addClass('selected');

            $('.js-gift-certificate-selected-design').val($img.data('value'));

            // Change the preview image.
            $previewImages.animate({opacity: 0, duration: 200}, function () {
                $previewImages.one('load', function () {
                    $(this).animate({opacity: 1, duration: 200});
                });

                $previewImages.attr('src', $img.attr('src').replace('-thumb', ''));
            });
        });

        $('.js-gift-certificate-design[data-default=true]').click();

        // Change the amount in the selected design to the selected value.
        var $fieldValue = $('.js-gift-certificate-value');
        $fieldValue.on('change', function (event) {
            setCardAmount(event.target.value);
        });
        setCardAmount($fieldValue.val());

        $('.gift-certificate-scope input').on('change', function (event) {
            var scope = $(event.target).val();
            var $scopedForm = $('.gift-certificate-scoped-form');
            var $contentContainer = $('.gift-certificate-alternate-form.' + scope);
            var content;

            if ($contentContainer.length) {
                $scopedForm.fadeOut(300, function () {
                    content = $contentContainer.html();
                    $contentContainer.html($scopedForm.html());
                    $scopedForm.html(content);

                    $contentContainer.removeClass(scope);
                    $contentContainer.addClass(scope === 'friend' ? 'myself' : 'friend');

                    $scopedForm.fadeIn(300);
                });
            }
        });

        $('.gift-certificate-details-form form').submit(function (event) {
            var $form = $(this);
            var validator = $form.validate();
            var showCart = function (response) {
                var splitted = response.split(Util.contentSplitter);
                var options;

                try {
                    options = JSON.parse(splitted[1]);
                } catch (err) {
                    options = {};
                }

                // Reset form fields after adding to cart
                for (var i = 0, element; (element = $form[0].elements[i++]); ) {
                    if (element.type === 'text' || element.type === 'textarea' || element.type === 'email') {
                        element.value = '';
                    }
                }

                CartOverlay.show(splitted[2]);
                Minicart.update(splitted[0], options);
            };

            event.preventDefault();
            if (validator.valid()) {
                Ajax.submitForm($form, function (response) {
                    try {
                        var jsonResponse = JSON.parse(response);
                        var validator = $form.validate();
                        let inputName;
                        let error;

                        if (jsonResponse.amountError) {
                            inputName = $form.find('.button.button-large').attr('name');
                            error = jsonResponse.amountError;
                        }

                        if (jsonResponse.mailError) {
                            inputName = $form.find('.confirm input').attr('name');
                            error = jsonResponse.mailError;
                        }

                        if (inputName) {
                            var errorObj = {};

                            errorObj[inputName] = error;
                            validator.showErrors(errorObj);
                        }
                    } catch (_) {
                        var $giftCertificateScope = $('.gift-certificate-scope input');

                        $($giftCertificateScope[0]).val('friend');
                        $($giftCertificateScope[1]).val('myself');
                        $($giftCertificateScope[0]).click();
                        $('[for="radio-design-1"]').click();
                        $('.js-gift-certificate-value').val($('.js-gift-certificate-value option:first').val());
                        $('.js-gift-certificate-value').trigger('change');
                        $.uniform.update();
                        showCart(response);
                    }
                });
            }
        });
    }

    if (document.getElementById('gift-certificate-balance')) {
        $('.check-balance').on('submit', function (event) {
            var $form = $(this);
            var $contentContainer = $('.giftcertificate-content');
            var validator = $form.validate();

            event.preventDefault();

            if (validator.valid()) {
                Progress.show($contentContainer);
                Ajax.submitForm($form, function (response) {
                    try {
                        var jsonResponse = JSON.parse(response);
                        var validator = $form.validate();

                        if (jsonResponse.certError) {
                            var inputName = $form.find('.cert-id').attr('name');
                            var errorObj = {};

                            errorObj[inputName] = jsonResponse.certError;
                            validator.showErrors(errorObj);
                        }
                    } catch (_) {
                        $contentContainer.html(response);
                    }

                    Progress.hide();
                });
            }
        });
    }

    $('.cert-id, .gift-cert-redemption-id').on('keyup', function (event) {
        var $this = $(this);
        $this.val($this.val().toUpperCase());
    });
}

exports.init = function () {
    initializeEvents();
};
